var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.406,
    height: 40.22,
    viewBox: "0 0 29.406 40.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(-360.178 -121.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M17.364,20.228a8.864,8.864,0,1,1,8.864-8.864A8.864,8.864,0,0,1,17.364,20.228Zm0-16.546a7.682,7.682,0,1,0,7.682,7.682,7.682,7.682,0,0,0-7.682-7.682Z",
    transform: "translate(355.228 128.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M29.728,30.552H6.091a.591.591,0,0,1-.591-.591V22.87a.8.8,0,0,1,0-.165c.567-1.962,2.364-3.321,4.018-4.515.39-.3.756-.567,1.1-.851a.6.6,0,0,1,.8.059,8.478,8.478,0,0,0,6.488,2.517A8.4,8.4,0,0,0,24.35,17.4a.6.6,0,0,1,.8-.059c.343.283.709.556,1.1.839C27.871,19.36,29.7,20.743,30.27,22.7a.8.8,0,0,1,0,.165v7.093a.591.591,0,0,1-.544.591ZM6.682,29.37H29.136V22.953c-.485-1.536-2.115-2.753-3.546-3.817l-.721-.544A9.738,9.738,0,0,1,17.909,21.1a9.8,9.8,0,0,1-6.961-2.506l-.733.544c-1.44,1.063-3.071,2.281-3.544,3.817Z",
    transform: "translate(354.682 131.598)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "settings-2-svgrepo-com",
    d: "M10.782,7.994l-.653,1.116-1.483-.5-.151.137A3.857,3.857,0,0,1,7.021,9.6l-.2.061-.305,1.507H5.2L4.9,9.658,4.7,9.6a3.857,3.857,0,0,1-1.473-.844l-.151-.137-1.483.5L.939,7.994,2.11,6.979l-.046-.2a3.7,3.7,0,0,1,0-1.677l.046-.2L.939,3.879l.653-1.116,1.483.494.151-.137A3.868,3.868,0,0,1,4.7,2.275l.2-.061L5.2.707H6.518l.305,1.507.2.061a3.859,3.859,0,0,1,1.473.845l.151.137,1.483-.5.653,1.116L9.611,4.894l.046.2a3.7,3.7,0,0,1,0,1.677l-.046.2,1.171,1.016ZM10.45,5.936a4.392,4.392,0,0,0-.072-.786l1.3-1.124-1.231-2.1-1.637.546a4.638,4.638,0,0,0-1.382-.793L7.088.01H4.633L4.3,1.675a4.557,4.557,0,0,0-1.383.793L1.276,1.922.045,4.027l1.3,1.124a4.373,4.373,0,0,0,0,1.571L.045,7.846l1.231,2.1L2.913,9.4A4.64,4.64,0,0,0,4.3,10.2l.337,1.666H7.088L7.426,10.2A4.556,4.556,0,0,0,8.808,9.4l1.637.547,1.231-2.1-1.3-1.125a4.392,4.392,0,0,0,.072-.786ZM5.86,3.5A2.44,2.44,0,1,0,8.3,5.936,2.443,2.443,0,0,0,5.86,3.5m0,4.183A1.743,1.743,0,1,1,7.6,5.936,1.745,1.745,0,0,1,5.86,7.679",
    transform: "translate(377.908 121.921)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrator);
export default __webpack_public_path__ + "static/media/administrator.eaf7c8ec3786b6a1b9d6db8a6bbb9d2e.svg";
export { ForwardRef as ReactComponent };